import { Link } from "react-router-dom";
import { CalendarHeart } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

export const CtaBanner = ({ title, subtitle, testid = "cta-banner" }) => {
  const { t, to } = useLang();
  const c = t.ctaBanner;
  return (
    <section data-testid={testid} className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-24">
      <FadeUp>
        <div className="relative overflow-hidden rounded-[2rem] bg-terracotta text-linen px-6 py-14 sm:px-12 sm:py-16 lg:px-20 text-center">
          <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-white/10 blur-2xl pointer-events-none" aria-hidden="true" />
          <div className="absolute -bottom-28 -right-20 w-80 h-80 rounded-full bg-espresso/15 blur-2xl pointer-events-none" aria-hidden="true" />
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-linen/70 mb-5">{c.kicker}</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-3xl mx-auto text-balance">
            {title || c.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-linen/85 max-w-xl mx-auto">{subtitle || c.subtitle}</p>
          <Link
            to={to("/booking")}
            data-testid={`${testid}-book-btn`}
            className="mt-9 inline-flex items-center gap-2 rounded-full bg-linen text-terracotta-dark px-8 py-4 text-base font-semibold transition-[background-color,transform] duration-200 hover:bg-white [@media(hover:hover)]:hover:-translate-y-0.5"
          >
            <CalendarHeart className="w-5 h-5" />
            {c.button}
          </Link>
        </div>
      </FadeUp>
    </section>
  );
};
